import {
  HEADER_REQUESTING,
  HEADER_REQUEST_SUCCESS,
  HEADER_REQUEST_ERROR,
  HEADER_SET_ACTIVE_BRANCH_REQUESTING,
  HEADER_SET_ACTIVE_BRANCH_SUCCESS,
  HEADER_SET_ACTIVE_BRANCH_ERROR,
} from './constants'

export const headerRequest = (client) => {  
  return {
    type: HEADER_REQUESTING,
    client,
  }
}

export const headerRequestSuccess = (headers) => {
  return {
    type: HEADER_REQUEST_SUCCESS,
    headers,
  }
}

export const headerRequestError =  (error) => {
  if (!error.response)
  {
    return {
      type: HEADER_REQUEST_ERROR,
      error,
    }
  }

  return {
    type: HEADER_REQUEST_ERROR,
    error: error.response.statusText,
  }
}

export const headerSetActiveBranchRequest = (client, formData) => {  
  return {
    type: HEADER_SET_ACTIVE_BRANCH_REQUESTING,
    client,
    formData
  }
}

export const headerSetActiveBranchSuccess =  (data) => {
  return {
    type: HEADER_SET_ACTIVE_BRANCH_SUCCESS,
    payload: data,
  }
}

export const headerSetActiveBranchError = (error) => {
  return {
    type: HEADER_SET_ACTIVE_BRANCH_ERROR,
    error,
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/actions.js